import React, { useEffect, useState } from "react";
import NavFront from "../Front/NavFront";
import Profile from "./Profile";
import Description from "./Description";
import Cont from "./Cont";
import styled from "styled-components";
import Discussions from "./Discussions";
import Tile from '../Front/Tile';
import FooterNew from '../../layouts/FooterNew';
import { db, auth } from '../../../firebase';
import user2 from '../../../assets/user.png';
import { useHistory } from "react-router";
import SignInDialog from './SignInDialog';
import Search from '../Front/Search';
import Footer from "../../layouts/Footer";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
// import "./scrollHori";

const useStyles = makeStyles((theme) => ({
    main: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        margin: "auto",
        padding: "0 30px 20px 18px",
        marginTop: "30px",
        '@media (max-width: 1000px)': {
            padding: "0 20px 20px 8px",
        },
        // '@media (max-width: 950px)': {
        //     marginTop: "65px"
        // },
        '@media (max-width: 815px)': {
            padding: "0 20px 20px 12px",
        },
        '@media (max-width: 450px)': {
            padding: "0 10px 20px 6px",
        },
    },
    grid: {
        display: "flex",
        flexDirection: "row",
        overflow: "scroll",
    },
    heading: {
        margin: "0px 0px 20px 12px",
        '@media (max-width: 815px)': {
            margin: "0px 0px 15px 8px",
        },
        '@media (max-width: 450px)': {
            margin: "0px 0px 15px 4px",
        },
    }
}));

const Folio = () => {
    const user = auth.currentUser;
    const [navClick, setnavClick] = useState(false);
    const postid = JSON.parse(localStorage.getItem("postid"))['postid'];
    let uid = '';
    if (localStorage.getItem('allowed') === '1') {
        uid = JSON.parse(localStorage.getItem("user"))['uid'];
    }
    // const uid = JSON.parse(localStorage.getItem("user"))['uid'];
    const [date, setdate] = useState("");

    const [category, setcategory] = useState("");
    const [description, setdescription] = useState("");
    const [title, settitle] = useState("");
    const [pdf, setpdf] = useState("");
    const [name, setName] = useState("");
    const [likecount, setlikeCount] = useState(0);
    const [liked, setLiked] = useState();
    const [follower, setFollower] = useState();
    const [saved, setSaved] = useState();
    const [followercount, setfollowerCount] = useState(0);
    const [readcount, setreadCount] = useState(0);
    const [read, setread] = useState();
    const [puid, setpuid] = useState("");
    const [profPic, setprofPic] = useState(null);
    const [post, Setpost] = useState([]);
    const [page, Setpage] = useState(0);
    const history = useHistory();
    const [searchtext, setsearchtext] = useState('');
    const [allposts, setallposts] = useState([]);
    const [searchtype, setsearchtype] = useState([]);
    const [exacttitle, setexacttitle] = useState('');
    const [searchtitle, setsearchtitle] = useState([]);
    const [searchClicked, setsearchClicked] = useState(false);
    const fetchfolio = async () => {

        var docRef = db.collection("posts").doc(postid);
        docRef.onSnapshot((doc) => {
            setpuid(doc.data().postedBy);
            setdate(doc.data().date_created.toDate().toLocaleString('default', { month: 'short' }) + " " + doc.data().date_created.toDate().getDate() + ", " + doc.data().date_created.toDate().getFullYear());
            setcategory(doc.data().category);
            setdescription(doc.data().description);
            settitle(doc.data().title);
            setpdf(doc.data().pdf_url);
            setName(doc.data().name);
            setLiked(doc.data().liked_By);
            setlikeCount(doc.data().like_Count);
            setread(doc.data().read_By);
            setreadCount(doc.data().read_Count);
            var docRef2 = db.collection("users").doc(doc.data().postedBy);
            docRef2.get().then((doc) => {
                setFollower(doc.data().follower);
                setfollowerCount(doc.data().follower_Count);
                setSaved(doc.data().saved);
                if (doc.data().profilePic === "") {
                    setprofPic(user2);
                }
                else {
                    setprofPic(doc.data().profilePic);
                }
            }).catch((error) => {
                console.log("Error getting document:", error);
            });
        })

        const response = db.collection("posts");
        const data = await response.limit(10).get()
        const arr = [];
        data.docs.forEach(item => {
            var data = item.data();
            data = { ...data, id: item.id }
            arr.push(data);
        })
        Setpost(arr);
    }
    useEffect(() => {

        fetchfolio();


        //


    }, [page]);
    //  useEffect(() => {

    //  }, [liked,likecount,follower,followercount,readcount]);
    const reaction = async () => {
        console.log(liked);
        let arr = [...liked];
        const uid = JSON.parse(localStorage.getItem("user"))['uid'];
        if (arr.indexOf(uid) > -1) {

            arr = arr.filter(e => e !== uid);
            setLiked(arr);
            setlikeCount(arr.length);
            await db.collection("posts").doc(postid).update({ liked_By: arr });
            await db.collection("posts").doc(postid).update({ like_Count: arr.length });
        }
        else {

            arr.push(uid);
            setLiked(arr);
            setlikeCount(arr.length);
            await db.collection("posts").doc(postid).update({ liked_By: arr });
            await db.collection("posts").doc(postid).update({ like_Count: arr.length });
        }

    }
    const Tofollow = async () => {
        console.log(follower);
        const uid = JSON.parse(localStorage.getItem("user"))['uid'];
        let arr = [...follower];
        if (puid !== uid) {
            if (arr.indexOf(uid) > -1) {

                arr = arr.filter(e => e !== uid);
                setFollower(arr);
                setfollowerCount(arr.length);
                // setfollow(true);
                await db.collection("users").doc(puid).update({ follower: arr });
                await db.collection("users").doc(puid).update({ follower_Count: arr.length });
            }
            else {
                // setfollow(false);
                arr.push(uid);
                setFollower(arr);
                setfollowerCount(arr.length);
                await db.collection("users").doc(puid).update({ follower: arr });
                await db.collection("users").doc(puid).update({ follower_Count: arr.length });
            }
        }


    }
    const Tosave = async () => {
        const uid = JSON.parse(localStorage.getItem("user"))['uid'];
        console.log(saved);
        let arr = [...saved];

        if (arr.indexOf(postid) > -1) {

            arr = arr.filter(e => e !== postid);
            setSaved(arr);

            await db.collection("users").doc(uid).update({ saved: arr });

        }
        else {

            arr.push(postid);
            setSaved(arr);
            await db.collection("users").doc(uid).update({ saved: arr });
        }



    }

    let ToRead = () => {

    }
    if (auth.currentUser) {
        ToRead = async (c_page, t_page) => {
            const uid = JSON.parse(localStorage.getItem("user"))['uid'];
            // console.log(read);
            // console.log(c_page);
            //   console.log(t_page);
            let arr = [...read];
            if (c_page >= Math.round(t_page / 2)) {
                if (arr.indexOf(uid) === -1) {

                    arr.push(uid);
                    setread(arr);
                    setreadCount(arr.length);
                    await db.collection("posts").doc(postid).update({ read_By: arr });
                    await db.collection("posts").doc(postid).update({ read_Count: arr.length });
                }
            }


        }
    }

    function tileid(x) {
        localStorage.setItem(
            "postid",
            JSON.stringify({
                postid: x,
            })
        );

        history.push(`/folio/${x}`);
        Setpage(x);
    }
    function profileid(y) {
        localStorage.setItem("profileid", JSON.stringify({ profileid: y }));
        history.push(`/user`)
    }

    const classes = useStyles();

    window.onload = function () {
        var element = document.querySelector("#sticky");

        element.addEventListener('wheel', (event) => {
            event.preventDefault();

            element.scrollBy({
                left: event.deltaY < 0 ? -30 : 30,
            });
        });
    }



    return (
        <React.Fragment>

            {/* Navbar */}
            <NavFront setnavClick={setnavClick} setsearchClicked={setsearchClicked} setexacttitle={setexacttitle} searchtitle={searchtitle} setsearchtitle={setsearchtitle} searchtext={searchtext} setsearchtype={setsearchtype} setsearchtext={setsearchtext} user={user} />
            {!searchClicked && searchtext !== '' ? <Search exacttitle={exacttitle} searchtitle={searchtitle} setsearchClicked={setsearchClicked} searchtype={searchtype} searchtext={searchtext} /> : null}

            <MainBox >
                {navClick ? <SignInDialog open={true} setnavClick={setnavClick} /> : null}
                <Profile title={title} Category={category} Date_c={date} D_Name={name} LikeCount={likecount} click={reaction} Tofollow={Tofollow} readc={readcount} followcount={followercount} postid={postid} puid={puid} prof={profPic} uid={uid} view_prof={profileid} />
                <LineMd />
                <Description Desc={description} />

            </MainBox>
            <Line />
            <PdfBox>
                <Cont pdfUrl={pdf} read={ToRead} id={postid} />
                <Discussions uid={uid} puid={puid} />
            </PdfBox>


            {/* <Suggestion>
                <Head>Suggestions</Head>
                <Box>

                    {post &&
                        post.map(p => {
                            return (<Tile Title={p.title} Image={p.img_url} id={p.id} onclick={tileid} Name={p.name} read={p.read_Count} />);
                        })}

                </Box>
            </Suggestion> */}

            <div className={classes.main}>
                <h5 className={classes.heading}>Suggestions</h5>

                <Grid className={classes.grid} id="sticky"
                >
                    {post &&
                        post.map(p => {
                            return (<Tile Title={p.title} Image={p.img_url} id={p.id} onclick={tileid} Name={p.name} read={p.read_Count} />);
                        })}
                    {/* <Tile Title={p.title} Image={p.img_url} id={p.id} onclick={tileid} Name={p.name} read={p.read_Count} setnavClick={props.setnavClick} /> */}
                </Grid>
            </div>



            <hr style={{ margin: 0, height: "0.8px" }} />
            <Footer />
        </React.Fragment>
    )
}

const MainBox = styled.div`
/* border:2px solid violet; */
    display:flex;
    flex-direction:row;
    // justify-content:center;
    padding-top: 90px;
    @media (max-width: 815px){
        flex-direction:column;
        align-items: center;
    };
`
const PdfBox = styled.div`
display:flex;
flex-direction:row;
    @media (max-width: 950px){
        justify-content: center;
        flex-direction:column;
        // align-items: center;
    };
`
const LineMd = styled.div`
    @media (max-width: 815px){
        border-bottom: 1.75px solid #C7C7C7;
        width: -webkit-fill-available;
        margin: 30px 20px;
    };
    @media (max-width: 450px){
        margin: 30px 10px;
    };
`
const Line = styled.div`
        border-bottom: 1.75px solid #C7C7C7;
        margin: 10px 30px 0px;
        @media (max-width: 1000px){
            margin: 10px 20px 0px;
        };
        @media (max-width: 815px){
            margin: 30px 20px 0px;
        };
        @media (max-width: 450px){
            margin: 30px 10px 0px;
        };
`

const Box = styled.div`
    /* margin:5px; */
    margin-left:30px;
    display:flex;
    flex-direction:row;
    flex-wrap:wrap;
    width:80%;

`
const Suggestion = styled.div`
    /* border:2px solid red; */

       margin-top: 70px;
    margin-left:auto;
    margin-right:auto;
`
const Head = styled.div`
    width: 128px;
height: 26px;
margin-left:30px;
margin-bottom:15px;
font-family: Rubik;
font-style: normal;
font-weight: normal;
font-size: 22px;
line-height: 26px;
text-align: center;
color: #000000;
`

export default Folio;









// import React, { useEffect, useState } from "react";
// import NavFront from "../Front/NavFront";
// import Profile from "./Profile";
// import Description from "./Description";
// import Cont from "./Cont";
// import styled from "styled-components";
// import Discussions from "./Discussions";
// import Tile from '../Front/Tile';
// import FooterNew from '../../layouts/FooterNew';
// import { db, auth } from '../../../firebase';
// import user2 from '../../../assets/user.png';
// import { useHistory } from "react-router";
// import SignInDialog from './SignInDialog';
// import Search from '../Front/Search';
// import Footer from "../../layouts/Footer";


// const Folio = () => {
//     const user = auth.currentUser;
//     const [navClick, setnavClick] = useState(false);
//     const postid = JSON.parse(localStorage.getItem("postid"))['postid'];
//     let uid = '';
//     if (localStorage.getItem('allowed') === '1') {
//         uid = JSON.parse(localStorage.getItem("user"))['uid'];
//     }
//     // const uid = JSON.parse(localStorage.getItem("user"))['uid'];
//     const [date, setdate] = useState("");

//     const [category, setcategory] = useState("");
//     const [description, setdescription] = useState("");
//     const [title, settitle] = useState("");
//     const [pdf, setpdf] = useState("");
//     const [name, setName] = useState("");
//     const [likecount, setlikeCount] = useState(0);
//     const [liked, setLiked] = useState();
//     const [follower, setFollower] = useState();
//     const [saved, setSaved] = useState();
//     const [followercount, setfollowerCount] = useState(0);
//     const [readcount, setreadCount] = useState(0);
//     const [read, setread] = useState();
//     const [puid, setpuid] = useState("");
//     const [profPic, setprofPic] = useState(null);
//     const [post, Setpost] = useState([]);
//     const [page, Setpage] = useState(0);
//     const history = useHistory();
//     const [searchtext, setsearchtext] = useState('');
//     const [allposts, setallposts] = useState([]);
//     const [searchtype, setsearchtype] = useState([]);
//     const [exacttitle, setexacttitle] = useState('');
//     const [searchtitle, setsearchtitle] = useState([]);
//     const [searchClicked, setsearchClicked] = useState(false);
//     const fetchfolio = async () => {

//         var docRef = db.collection("posts").doc(postid);
//         docRef.onSnapshot((doc) => {
//             setpuid(doc.data().postedBy);
//             setdate(doc.data().date_created.toDate().toLocaleString('default', { month: 'short' }) + " " + doc.data().date_created.toDate().getDate() + ", " + doc.data().date_created.toDate().getFullYear());
//             setcategory(doc.data().category);
//             setdescription(doc.data().description);
//             settitle(doc.data().title);
//             setpdf(doc.data().pdf_url);
//             setName(doc.data().name);
//             setLiked(doc.data().liked_By);
//             setlikeCount(doc.data().like_Count);
//             setread(doc.data().read_By);
//             setreadCount(doc.data().read_Count);
//             var docRef2 = db.collection("users").doc(doc.data().postedBy);
//             docRef2.get().then((doc) => {
//                 setFollower(doc.data().follower);
//                 setfollowerCount(doc.data().follower_Count);
//                 setSaved(doc.data().saved);
//                 if (doc.data().profilePic === "") {
//                     setprofPic(user2);
//                 }
//                 else {
//                     setprofPic(doc.data().profilePic);
//                 }
//             }).catch((error) => {
//                 console.log("Error getting document:", error);
//             });
//         })

//         const response = db.collection("posts");
//         const data = await response.limit(10).get()
//         const arr = [];
//         data.docs.forEach(item => {
//             var data = item.data();
//             data = { ...data, id: item.id }
//             arr.push(data);
//         })
//         Setpost(arr);
//     }
//     useEffect(() => {

//         fetchfolio();


//         //


//     }, [page]);
//     //  useEffect(() => {

//     //  }, [liked,likecount,follower,followercount,readcount]);
//     const reaction = async () => {
//         console.log(liked);
//         let arr = [...liked];
//         const uid = JSON.parse(localStorage.getItem("user"))['uid'];
//         if (arr.indexOf(uid) > -1) {

//             arr = arr.filter(e => e !== uid);
//             setLiked(arr);
//             setlikeCount(arr.length);
//             await db.collection("posts").doc(postid).update({ liked_By: arr });
//             await db.collection("posts").doc(postid).update({ like_Count: arr.length });
//         }
//         else {

//             arr.push(uid);
//             setLiked(arr);
//             setlikeCount(arr.length);
//             await db.collection("posts").doc(postid).update({ liked_By: arr });
//             await db.collection("posts").doc(postid).update({ like_Count: arr.length });
//         }

//     }
//     const Tofollow = async () => {
//         console.log(follower);
//         const uid = JSON.parse(localStorage.getItem("user"))['uid'];
//         let arr = [...follower];
//         if (puid !== uid) {
//             if (arr.indexOf(uid) > -1) {

//                 arr = arr.filter(e => e !== uid);
//                 setFollower(arr);
//                 setfollowerCount(arr.length);
//                 // setfollow(true);
//                 await db.collection("users").doc(puid).update({ follower: arr });
//                 await db.collection("users").doc(puid).update({ follower_Count: arr.length });
//             }
//             else {
//                 // setfollow(false);
//                 arr.push(uid);
//                 setFollower(arr);
//                 setfollowerCount(arr.length);
//                 await db.collection("users").doc(puid).update({ follower: arr });
//                 await db.collection("users").doc(puid).update({ follower_Count: arr.length });
//             }
//         }


//     }
//     const Tosave = async () => {
//         const uid = JSON.parse(localStorage.getItem("user"))['uid'];
//         console.log(saved);
//         let arr = [...saved];

//         if (arr.indexOf(postid) > -1) {

//             arr = arr.filter(e => e !== postid);
//             setSaved(arr);

//             await db.collection("users").doc(uid).update({ saved: arr });

//         }
//         else {

//             arr.push(postid);
//             setSaved(arr);
//             await db.collection("users").doc(uid).update({ saved: arr });
//         }



//     }

//     let ToRead = () => {

//     }
//     if (auth.currentUser) {
//         ToRead = async (c_page, t_page) => {
//             const uid = JSON.parse(localStorage.getItem("user"))['uid'];
//             // console.log(read);
//             // console.log(c_page);
//             //   console.log(t_page);
//             let arr = [...read];
//             if (c_page >= Math.round(t_page / 2)) {
//                 if (arr.indexOf(uid) === -1) {

//                     arr.push(uid);
//                     setread(arr);
//                     setreadCount(arr.length);
//                     await db.collection("posts").doc(postid).update({ read_By: arr });
//                     await db.collection("posts").doc(postid).update({ read_Count: arr.length });
//                 }
//             }


//         }
//     }

//     function tileid(x) {
//         localStorage.setItem(
//             "postid",
//             JSON.stringify({
//                 postid: x,
//             })
//         );

//         history.push(`/folio/${x}`);
//         Setpage(x);
//     }
//     function profileid(y) {
//         localStorage.setItem("profileid", JSON.stringify({ profileid: y }));
//         history.push(`/user`)
//     }
//     const Line = ({ color }) => (
//         <hr
//             style={{
//                 color: color,
//                 width: '1430px',
//                 position: "relative",
//                 top: '40px',
//                 margin: "auto",
//                 marginLeft: '2.2vw',
//                 marginBottom: '1vh'
//             }}
//         />
//     );
//     return (
//         <React.Fragment>
//             {/* Navbar */}
//             <NavFront setnavClick={setnavClick} setsearchClicked={setsearchClicked} setexacttitle={setexacttitle} searchtitle={searchtitle} setsearchtitle={setsearchtitle} searchtext={searchtext} setsearchtype={setsearchtype} setsearchtext={setsearchtext} user={user} />
//             {!searchClicked && searchtext !== '' ? <Search exacttitle={exacttitle} searchtitle={searchtitle} setsearchClicked={setsearchClicked} searchtype={searchtype} searchtext={searchtext} /> : null}

//             <MainBox >
//                 {navClick ? <SignInDialog open={true} setnavClick={setnavClick} /> : null}
//                 <Profile title={title} Category={category} Date_c={date} D_Name={name} LikeCount={likecount} click={reaction} Tofollow={Tofollow} readc={readcount} followcount={followercount} postid={postid} puid={puid} prof={profPic} uid={uid} view_prof={profileid} />
//                 <Description Desc={description} />

//             </MainBox>
//             <Line color="#C7C7C7" />
//             <div style={{ display: 'flex' }}>
//                 <Cont pdfUrl={pdf} read={ToRead} id={postid} />
//                 <Discussions uid={uid} puid={puid} />
//             </div>


//             <Suggestion>
//                 <Head>Suggestions</Head>
//                 <Box>

//                     {post &&
//                         post.map(p => {
//                             return (<Tile Title={p.title} Image={p.img_url} id={p.id} onclick={tileid} Name={p.name} read={p.read_Count} />);
//                         })}

//                 </Box>
//             </Suggestion>

//             <hr style={{ margin: 0, height: "0.8px" }} />
//             {/* Footer */}
//             <Footer />
//         </React.Fragment>
//     )
// }
// const MainBox = styled.div`
// /* border:2px solid violet; */
//     display:flex;
//     flex-direction:row;
//     justify-content:space-around;
//     padding-top: 110px;
// `
// const Box = styled.div`
//     /* margin:5px; */
//     margin-left:30px;
//     display:flex;
//     flex-direction:row;
//     flex-wrap:wrap;
//     width:80%;

// `
// const Suggestion = styled.div`
//     /* border:2px solid red; */

//        margin-top: 70px;
//     margin-left:auto;
//     margin-right:auto;
// `
// const Head = styled.div`
//     width: 128px;
// height: 26px;
// margin-left:30px;
// margin-bottom:15px;
// font-family: Rubik;
// font-style: normal;
// font-weight: normal;
// font-size: 22px;
// line-height: 26px;
// text-align: center;
// color: #000000;
// `

// export default Folio;

